import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "styles/index.css";
import "./assets/fonts/Sk-Modernist-Bold.otf";
import "./assets/fonts/Sk-Modernist-Regular.otf";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
